import {
  posterSrc,
  posterSrcSet,
} from '@repo/supergraph/structuredContent/hydration/WpVideo/thumbnails';
import type { Video } from '@repo/supergraph-schemas/structuredContent/hydration/WpVideo/types';
import type { IVideoOptions } from './types';

export const getVideoUrl = (id: string, options: IVideoOptions) => {
  const queryParams = new URLSearchParams({
    autoplay: options.showPreview === false ? '0' : '1',
    rel: options.showRelatedVideos ? '1' : '0',
    color: 'white',
  });
  return `https://www.youtube.com/embed/${id}?${queryParams.toString()}`;
};

export const getWebPImageUrl = (imageUrl: string): string =>
  (imageUrl && imageUrl.replace('/vi/', '/vi_webp/').replace('.jpg', '.webp')) || imageUrl;

export const getVideoImageSRC = (video: Video) =>
  posterSrc(video.youtubeVideo.id, video.youtubeVideo.snippet.thumbnails);

export const getVideoImageSRCSet = (video: Video) =>
  posterSrcSet(video.youtubeVideo.id, video.youtubeVideo.snippet.thumbnails);
